<template>
  <div class="firmSituation">
      <el-tabs class="acitiveNav" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane class="acitiveNav" v-for="(item,index) in activeNav"
            :key="index"
            :label="item.lable"
            :name="item.name">
                <editor  v-if="item.name === 'productServe' " v-model="form.product" :disabled="firmDataStatus"></editor>
                <editor  v-if="item.name === 'teamIntroduce' " v-model="form.teamIntroduce" :disabled="firmDataStatus"></editor>
                <editor  v-if="item.name === 'development' " v-model="form.developProcedure" :disabled="firmDataStatus"></editor>
                <editor  v-if="item.name === 'partner' " v-model="form.partner" :disabled="firmDataStatus"></editor>

                <div v-if="item.name === 'honor'">
                    <el-form :model="form"
                      ref="form"
                      label-width="150px"
                      label-position='right'
                      :disabled="firmDataStatus">
                        <el-form-item label="荣誉简述：" >
                          <el-input type="textarea"
                          v-model="form.honorSketch"
                          :autosize='{ minRows: 6, maxRows: 6 }'
                          maxlength="250"
                          placeholder="请输入荣誉简述，最多250个字符"
                          class="input-box">
                          </el-input>
                        </el-form-item>

                        <el-form-item label="荣誉资质图片：">
                            <!-- <upload-btn @imgUrlList="gloryImgsList" :title="gloryImgList"></upload-btn> -->
                             <multi-upload v-model="gloryImgList"
                                  :keyid="gloryImgList"
                                  :imgWidth='1200'
                                  :imgHeight='600'
                                  :typeArray="['png']"
                                  :maxCount='99'
                                  :sizetxt='String("建议像素303*216,PNG，不超过10M")'>
                            </multi-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div v-if="item.name === 'firmSituation'">
                    <div class="firm-moreInfo">企业基本信息</div>
                        <el-form :model="form"
                          :rules="infoRules"
                          ref="form"
                          label-width="100px"
                          label-position='right'
                          :disabled="firmDataStatus">
                            <el-form-item label="企业名称：" prop="firmName"  ref="viewBox">
                                <el-autocomplete
                                  class="input-boxs"
                                  v-model="form.firmName"
                                  :fetch-suggestions="querySearch"
                                  placeholder="请输入企业名称自动获取企业信息"
                                  :trigger-on-focus="false"
                                  @select="handleSelect"
                                  >
                                </el-autocomplete>
                            </el-form-item>
                        </el-form>
                    <div class="firm-baseInfo">
                      <p class="base-info-fline" v-if="firmInfo">
                        <span class="dinfo">注册地址：{{firmInfo.registryAddress ? firmInfo.registryAddress : tit }}</span>
                        <span class="dinfo">联系电话：{{firmInfo.phone ? firmInfo.phone : tit}}</span>
                        <span class="dinfo">官网网址：{{firmInfo.website ? firmInfo.website: tit}}</span>
                        <span class="dinfo">法人代表：{{firmInfo.legalRepresentative ? firmInfo.legalRepresentative : tit}}</span>
                        <span class="dinfo">成立日期：{{firmInfo.foundationDate ? firmInfo.foundationDate.slice(0,3).join('-') : tit }}</span>
                        <span class="dinfo">注册资本：{{firmInfo.registryCapital ? firmInfo.registryCapital : tit}}</span>
                        <span class="dinfo">公司类型：{{firmInfo.type ? firmInfo.type : tit}}</span>
                        <span class="dinfo">主要人员：{{firmInfo.keyPersonnel ? firmInfo.keyPersonnel : tit}}</span>

                      </p>
                      <p class="base-info-sline" v-if="firmInfo">
                        <span class="dinfo">行业分类：{{firmInfo.industry ? firmInfo.industry : tit}}</span>
                        <span class="dinfo">经营状态：{{firmInfo.bussinessState  ? firmInfo.bussinessState : tit}}</span>
                        <span class="dinfo">人员规模：{{firmInfo.scale  ? firmInfo.scale : tit}}</span>
                        <span class="dinfo">是否高新：{{firmInfo.isHightech ? firmInfo.isHightech : tit}}</span>
                        <span class="dinfo">是否上市：{{firmInfo.isPublic  ? firmInfo.isPublic : tit}}</span>
                        <span class="dinfo">知识产权数：{{firmInfo.patentNumber ? firmInfo.patentNumber : tit}}</span>
                        <span class="dinfo">社会统一信用代码：{{firmInfo.creditCode  ? firmInfo.creditCode : tit}}</span>
                      </p>
                    </div>

                    <div class="firm-moreInfo">企业额外信息</div>
                    <el-form  :model="form"
                      ref="form"
                      label-width="95px"
                      label-position='right'
                      :disabled="firmDataStatus"
                      :rules="rules">
                        <el-form-item label="企业LOGO：">
                            <!-- <upload-btn @imgUrls="imgUpload" :title="firmLogo"></upload-btn> -->
                             <multi-upload v-model="firmLogo"
                                  :keyid="firmLogo"
                                  :imgWidth='150'
                                  :imgHeight='150'
                                  :typeArray="['png']"
                                  :maxCount='1'
                                  :sizetxt='String("建议像素150*150,PNG，不超过10M,最多1张")'>
                            </multi-upload>
                        </el-form-item>

                        <el-form-item label="企业图片：">
                            <!-- <upload-btn @imgUrlList="firmImgsList" :title="firmImgList"></upload-btn> -->
                            <multi-upload v-model="firmImgList"
                                  :keyid="firmImgList"
                                  :imgWidth='800'
                                  :imgHeight='800'
                                  :typeArray="['png']"
                                  :maxCount='5'
                                  :sizetxt='String("建议像素460*300,PNG，不超过10M,最多5张")'>
                            </multi-upload>
                        </el-form-item>

                        <el-form-item label="企业简介：" prop="introductory">
                            <el-input type="textarea"
                              v-model="form.introductory"
                              :autosize='{ minRows: 6, maxRows: 6 }'
                              :maxlength="250"
                              placeholder="请输入企业简介，最多250个字符"
                              class="input-box">
                            </el-input>
                        </el-form-item>

                        <el-form-item label="上一年营收（万元）：" >
                            <el-input class="input-boxs" v-model="form.lastIncome" placeholder="请输入金额"></el-input>
                        </el-form-item>

                        <el-form-item label="融资轮次：" >
                            <!-- <el-select class="input-boxs" v-model="form.financingTurn" placeholder="请选择融资轮次">
                                  <el-option
                                    v-for="(item,index) in financingTurnList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                  </el-option>
                            </el-select> -->
                            <el-input class="input-boxs" v-model="form.financingTurn" placeholder="请输入融资轮次"></el-input>
                        </el-form-item>

                        <el-form-item label="融资金额（万元）："  >
                          <el-input class="input-boxs" v-model="form.financingMoney" placeholder="请输入金额"></el-input>
                        </el-form-item>

                        <el-form-item label="所属地区：">
                          {{firmArea}}
                        </el-form-item>
                    </el-form>
                </div>
        </el-tab-pane>
      </el-tabs>

      <el-divider></el-divider>
      <div v-if="thisType != 1">
            <el-button class="btn-style" type="success" @click="pageSave">保存</el-button>
            <el-button class="btn-style" type="info" @click="yulan()">预览</el-button>
            <el-button v-if="!this.$route.query.Ptime" class="btn-style" type="primary" @click="pageRelease">发布</el-button>
            <!-- <el-button class="btn-style" type="primary" v-if="status ===1 " @click="pageRelease">线</el-button> -->
      </div>

        <el-dialog
          title="企业详情预览"
          :visible.sync="centerDialogVisible"
          width="90%"
          center>
          <firm-detail-preview v-if="centerDialogVisible"></firm-detail-preview>
        </el-dialog>
  </div>
</template>

<script>
import Editor from '@/components/editor.vue'
// import UploadBtn from '@/components/uploadBtn.vue'
import mixinFun from '@/utils/mixin'
// import FirmDetail from '../../firm/firmDetail.vue'
import FirmDetailPreview from '../../firm/firmDetailPreview.vue'
import MultiUpload from '../../../components/multiUpload.vue'

export default {
  name: 'firmSituation',
  props: {},
  components: {
    Editor,
    // UploadBtn,
    FirmDetailPreview,
    MultiUpload
  },
  mixins: [mixinFun],
  data () {
    return {
      tagIsShow: 0,
      nowdata: '',
      centerDialogVisible: false,
      activeName: 'firmSituation',
      activeNav: [
        {
          lable: '企业概况',
          name: 'firmSituation'
        },
        {
          lable: '产品服务',
          name: 'productServe'
        },
        {
          lable: '团队介绍',
          name: 'teamIntroduce'
        },
        {
          lable: '荣誉资质',
          name: 'honor'
        },
        {
          lable: '发展历程',
          name: 'development'
        },
        {
          lable: '合作伙伴',
          name: 'partner'
        }
      ],
      financingTurnList: [
        '种子轮',
        '天使轮',
        'A轮',
        'B轮',
        'C轮',
        'D轮',
        'E轮',
        'F轮'
      ], // 融资轮次
      form: {
        firmName: null,
        introductory: null, // 企业简介
        lastIncome: null, // 上一年营收
        financingTurn: null, // 融资轮次
        financingMoney: null, // 融资金额
        area: null, // 所属地区
        honorSketch: null, // 荣誉简述
        product: '', // 产品服务
        teamIntroduce: '', // 团队介绍
        developProcedure: '', // 发展历程
        partner: '' // 合作伙伴
      },
      firmLogo: [], // 企业logo
      firmImgList: [], // 企业图片
      gloryImgList: [], // 荣誉资质
      status: 0,
      infoRules: {
        firmName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ]
      },
      rules: {
        introductory: [
          { message: '请输入企业名称', trigger: 'blur' },
          { min: 1, max: 250, message: '最多250个字符', trigger: 'blur' }
        ]
      },
      firmArea: '', // 企业所在园区所属地区
      firmInfo: {},
      isHightech: '',
      // tit: form.firmName ? '-' : '请先确认企业名称',
      tit: '请先确认企业名称',
      restaurants: [],
      picUrl: '',
      firmDataStatus: null,
      firmId: '', // 新增企业ID
      knowledgeNums: 0,
      page: 1,
      size: 20,
      firmInfoCheck: {},
      isType: false,
      thisType: 0,
      Published: '0'
    }
  },
  computed: {},
  watch: {
    isType (v) {
      console.log(v)
      if (v === true) {
        this.tit = '-'
      }
    }
  },
  created () {
    this.thisType = this.$route.query.type
    this.getFirmArea()
    this.firmId = this.$route.query.id ? this.$route.query.id : null

    // console.log('企业名称')
    // console.log(this.form.firmName)
    // console.log(this.$route.query.status)

    this.form.firmName = this.$route.query.name ? this.$route.query.name : null
    if (this.$route.query.status === '1') {
      this.tit = '-'
      this.firmDataStatus = true
    } else if (this.$route.query.status === '2') {
      this.tit = '-'
      this.firmDataStatus = false
    }

    // if (location.href.indexOf('#reloaded') === -1) {
    //   location.href = location.href + '#reloaded'
    //   location.reload()
    // }
  },
  mounted () {
    this.getFirmInfo() // 企业基本信息
    this.firmDataCheck() // 企业信息查看

    this.$parent.sureitem = '/compantInfo'

    // if (location.href.indexOf('#reloaded') === -1) {
    //   location.href = location.href + '#reloaded'
    //   location.reload()
    // }
  },
  methods: {
    yulan () {
      console.log(this.firmInfoCheck)
      if (sessionStorage.getItem('firmInfoCheck')) {
        this.tagIsShow = JSON.parse(sessionStorage.getItem('firmInfoCheck')).appraiseTime
        console.log(JSON.parse(sessionStorage.getItem('firmInfoCheck')).appraiseTime)
      }

      const obj = {
        appraiseTime: this.tagIsShow,
        companyName: this.form.firmName ? this.form.firmName : null, // 企业名称
        name: this.form.firmName ? this.form.firmName : null, // 企业名称
        district: this.firmArea, // 所属地区
        registryAddress: this.firmInfo.registryAddress ? this.firmInfo.registryAddress : null, // 注册地址
        phone: this.firmInfo.phone ? this.firmInfo.phone : null, // 联系电话
        website: this.firmInfo.website ? this.firmInfo.website : null, // 网址

        // isPublished: this.firmArea ? this.status : null, // 是否发布
        // publishTime: null, // 最近发布时间
        logo: this.firmLogo ? this.firmLogo.join(',') : null, // 企业logo
        companyPicture: this.firmImgList ? this.firmImgList : null, // 企业图片
        detail: this.form.introductory ? this.form.introductory : null, // 企业简介
        income: this.form.lastIncome ? this.form.lastIncome : null, // 去年营收
        financialTurn: this.form.financingTurn ? this.form.financingTurn : null, // 融资轮次
        financialNums: this.form.financingMoney ? this.form.financingMoney : null, // 融资金额

        industry: this.firmInfo.industry ? this.firmInfo.industry : null, // 行业分类
        bussinessState: this.firmInfo.bussinessState ? this.firmInfo.bussinessState : null, // 经营状态
        scale: this.firmInfo.scale ? this.firmInfo.scale : null, // 人员规模
        legalRepresentative: this.firmInfo.legalRepresentative ? this.firmInfo.legalRepresentative : null, // 法人
        isHightech: this.firmInfo.isHightech ? this.firmInfo.isHightech : null, // 高新
        foundationDate: this.firmInfo.foundationDate ? this.firmInfo.foundationDate : null, // 成立日期
        isPublic: this.firmInfo.isPublic ? this.firmInfo.isPublic : null, // 上市
        registryCapital: this.firmInfo.registryCapital ? this.firmInfo.registryCapital : null, // 注册资本
        patentNumber: this.patentNumber ? this.patentNumber : null, // 知识产权
        type: this.firmInfo.type ? this.firmInfo.type : null, // 公司类型
        creditCode: this.firmInfo.creditCode ? this.firmInfo.creditCode : null, // 信用代码
        keyPersonnel: this.firmInfo.keyPersonnel ? this.firmInfo.keyPersonnel : null, // 主要人员

        product: this.form.product ? this.form.product : null, // 产品服务
        teamIntroduce: this.form.teamIntroduce ? this.form.teamIntroduce : null, // 团队介绍
        gloryDetail: this.form.honorSketch ? this.form.honorSketch : null, // 荣誉描述
        gloryPicture: this.gloryImgList ? this.gloryImgList : null, // 荣誉资质
        developProcedure: this.form.developProcedure !== null ? this.form.developProcedure : null, // 发展历程
        partner: this.form.partner ? this.form.partner : null // 合作伙伴

      }

      // console.log(this.form.honorSketch)
      // this.firmInfoCheck.info = obj
      this.firmInfoCheck = obj

      sessionStorage.setItem('firmInfoCheck', JSON.stringify(this.firmInfoCheck))
      this.centerDialogVisible = true
    },

    // 企业名模糊查询
    async querySearch (queryString, cb) {
      console.log(this.form.firmName)
      try {
        const res = await this.$get(this.$url.companyInfoManage.firmNameSuggest, {
          name: this.form.firmName
        })

        const { code, msg, data } = res.data
        if (code === 200) {
          var resArr = []

          if (data.result !== null) {
            data.result.items.map((item) => {
              item.value = item.name

              resArr = resArr.concat(item)
            })
            this.restaurants = resArr

            cb(resArr)
          }
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    handleSelect (item) {
      this.form.firmName = item.name
      this.tit = (this.form.firmName !== null ? '-' : '请先确认企业名称')
      this.getFirmInfo()
      // this.getknowledgeData()
    },

    // 企业详细信息(格兰德接口基本信息)
    async getFirmInfo () {
      try {
        if (this.form.firmName === null) {
          return false
        }

        const res = await this.$get(this.$url.companyInfoManage.firmBaseInfo, {
          companyName: this.form.firmName
        })

        const { code, msg, data } = res.data

        if (code === 200) {
          this.firmInfo = data
          console.log(data)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 时间日期处理
    formatArray (dateArr) {
      const year = dateArr[0]
      const month = ('0' + dateArr[1]).slice(-2)
      const day = ('0' + dateArr[2]).slice(-2)
      const hour = ('0' + dateArr[3]).slice(-2)
      const mininus = ('0' + dateArr[4]).slice(-2)
      let second = '00'
      if (dateArr[5]) {
        second = ('0' + dateArr[5]).slice(-2)
      }
      return year + '-' + month + '-' + day + ' ' + hour + ':' + mininus + ':' + second
    },

    // 企业知识产权数查询
    // async getknowledgeData () {
    //   try {
    //     const res = await this.$get(
    //       this.$url.companyInfoManage.firmIntellectualProperty,
    //       {
    //         name: this.form.firmName
    //       }
    //     )

    //     const { code, msg, data } = res.data
    //     if (code === 200) {
    //       let knowledgeNum = 0
    //       Object.keys(data.result).forEach((item) => {
    //         // knowledgeNum = knowledgeNum + Number(data.result[item])
    //         knowledgeNum =
    //           Number(data.result.opusCopyCount) +
    //           Number(data.result.patentCount) +
    //           Number(data.result.tmCount)
    //         return knowledgeNum
    //       })

    //       this.knowledgeNums = knowledgeNum
    //     } else {
    //       this.$message.error(msg)
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },

    // 获取企业所在园区所属地区
    async getFirmArea () {
      try {
        const res = await this.$post(this.$url.companyInfoManage.firmArea)

        const { code, msg } = res.data
        if (code === 200) {
          this.firmArea = msg
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 企业数据查看
    firmDataCheck () {
      if (this.$route.query.id) {
        this.firmInfoCheck = JSON.parse(sessionStorage.getItem('firmInfoCheck'))
        console.log(this.firmInfoCheck)
        this.form.introductory = this.firmInfoCheck.detail // 企业简介
        this.form.lastIncome = this.firmInfoCheck.income // 上一年营收
        this.form.financingTurn = this.firmInfoCheck.financialTurn // 融资轮次
        this.form.financingMoney = this.firmInfoCheck.financialNums // 融资金额
        this.form.honorSketch = this.firmInfoCheck.gloryDetail // 荣誉简述
        this.form.product = this.firmInfoCheck.product // 产品服务
        this.form.teamIntroduce = this.firmInfoCheck.teamIntroduce // 团队介绍
        this.form.developProcedure = this.firmInfoCheck.developProcedure // 发展历程
        this.form.partner = this.firmInfoCheck.partner // 合作伙伴
        this.firmLogo = this.firmInfoCheck.logo ? this.firmInfoCheck.logo.split(' ') : []// 企业logo

        // console.log(typeof (this.firmInfoCheck.companyPicture))

        if (typeof (this.firmInfoCheck.companyPicture) === 'string') {
          this.firmImgList = (this.firmInfoCheck.companyPicture.length > 0) ? this.firmInfoCheck.companyPicture.split(',') : []// 企业图片
          this.gloryImgList = (this.firmInfoCheck.gloryPicture.length > 0) ? this.firmInfoCheck.gloryPicture.split(',') : [] // 荣誉资质图片
        } else {
          this.firmImgList = (this.firmInfoCheck.companyPicture.length > 0) ? this.firmInfoCheck.companyPicture : []// 企业图片
          this.gloryImgList = (this.firmInfoCheck.gloryPicture.length > 0) ? this.firmInfoCheck.gloryPicture : [] // 荣誉资质图片
        }
      }
      // console.log(this.firmInfoCheck.info)
    },

    // 企业数据上传(新增)
    async firmDataUpload () {
      try {
        const res = await this.$post(this.$url.companyInfoManage.firmDataUp, {
          isPublished: this.Published, // 是否发布
          publishTime: null, // 最近发布时间

          companyName: this.form.firmName ? this.form.firmName : null, // 企业名称
          name: this.form.firmName ? this.form.firmName : null, // 企业名称
          district: this.firmArea, // 所属地区
          registryAddress: this.firmInfo.registryAddress ? this.firmInfo.registryAddress : null, // 注册地址
          phone: this.firmInfo.phone ? this.firmInfo.phone : null, // 联系电话
          website: this.firmInfo.website ? this.firmInfo.website : null, // 网址

          logo: this.firmLogo ? this.firmLogo.join(',') : null, // 企业logo
          companyPicture: this.firmImgList ? this.firmImgList : null, // 企业图片
          detail: this.form.introductory ? this.form.introductory : null, // 企业简介
          income: this.form.lastIncome ? this.form.lastIncome : null, // 去年营收
          financialTurn: this.form.financingTurn ? this.form.financingTurn : null, // 融资轮次
          financialNums: this.form.financingMoney ? this.form.financingMoney : null, // 融资金额

          industry: this.firmInfo.industry ? this.firmInfo.industry : null, // 行业分类
          bussinessState: this.firmInfo.bussinessState ? this.firmInfo.bussinessState : null, // 经营状态
          scale: this.firmInfo.scale ? this.firmInfo.scale : null, // 人员规模
          legalRepresentative: this.firmInfo.legalRepresentative ? this.firmInfo.legalRepresentative : null, // 法人
          isHightech: this.firmInfo.isHightech ? this.firmInfo.isHightech : null, // 高新
          foundationDate: this.firmInfo.foundationDate ? this.formatArray(this.firmInfo.foundationDate) : null, // 成立日期
          isPublic: this.firmInfo.isPublic ? this.firmInfo.isPublic : null, // 上市
          registryCapital: this.firmInfo.registryCapital ? this.firmInfo.registryCapital : null, // 注册资本
          patentNumber: this.patentNumber ? this.patentNumber : null, // 知识产权
          type: this.firmInfo.type ? this.firmInfo.type : null, // 公司类型
          creditCode: this.firmInfo.creditCode ? this.firmInfo.creditCode : null, // 信用代码
          keyPersonnel: this.firmInfo.keyPersonnel ? this.firmInfo.keyPersonnel : null, // 主要人员

          product: this.form.product ? this.form.product : null, // 产品服务
          teamIntroduce: this.form.teamIntroduce ? this.form.teamIntroduce : null, // 团队介绍
          gloryDetail: this.form.honorSketch ? this.form.honorSketch : null, // 荣誉描述
          gloryPicture: this.gloryImgList ? this.gloryImgList : null, // 荣誉资质
          developProcedure: this.form.developProcedure !== null ? this.form.developProcedure : null, // 发展历程
          partner: this.form.partner ? this.form.partner : null // 合作伙伴
        })

        const { code, msg } = res.data
        if (code === 200) {
          this.firmId = msg
          this.$message.success('保存成功！')
          // this.$router.push('/compantInfo')
          // console.log(data)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 企业数据上传(修改)
    async firmDataChange () {
      const res = await this.$post(this.$url.companyInfoManage.firmDataChange, {

        basicId: this.firmId,
        // isPublished: this.status !== null ? this.status : null, // 是否发布
        // publishTime: null, // 最近发布时间

        isPublished: this.Published, // 是否发布
        publishTime: null, // 最近发布时间

        companyName: this.form.firmName ? this.form.firmName : null, // 企业名称
        name: this.form.firmName ? this.form.firmName : null, // 企业名称
        district: this.firmArea !== null ? this.firmArea : null, // 所属地区
        registryAddress: this.firmInfo.registryAddress ? this.firmInfo.registryAddress : null, // 注册地址
        phone: this.firmInfo.phone ? this.firmInfo.phone : null, // 联系电话
        website: this.firmInfo.website ? this.firmInfo.website : null, // 网址

        logo: this.firmLogo ? this.firmLogo.join(',') : null, // 企业logo
        companyPicture: this.firmImgList ? this.firmImgList : null, // 企业图片
        detail: this.form.introductory ? this.form.introductory : null, // 企业简介
        income: this.form.lastIncome ? this.form.lastIncome : null, // 去年营收
        financialTurn: this.form.financingTurn ? this.form.financingTurn : null, // 融资轮次
        financialNums: this.form.financingMoney ? this.form.financingMoney : null, // 融资金额

        industry: this.firmInfo.industry ? this.firmInfo.industry : null, // 行业分类
        bussinessState: this.firmInfo.bussinessState ? this.firmInfo.bussinessState : null, // 经营状态
        scale: this.firmInfo.scale ? this.firmInfo.scale : null, // 人员规模
        legalRepresentative: this.firmInfo.legalRepresentative ? this.firmInfo.legalRepresentative : null, // 法人
        isHightech: this.firmInfo.isHightech ? this.firmInfo.isHightech : null, // 高新
        foundationDate: this.firmInfo.foundationDate ? this.formatArray(this.firmInfo.foundationDate) : null, // 成立日期
        isPublic: this.firmInfo.isPublic ? this.firmInfo.isPublic : null, // 上市
        registryCapital: this.firmInfo.registryCapital ? this.firmInfo.registryCapital : null, // 注册资本
        patentNumber: this.patentNumber ? this.patentNumber : null, // 知识产权
        type: this.firmInfo.type ? this.firmInfo.type : null, // 公司类型
        creditCode: this.firmInfo.creditCode ? this.firmInfo.creditCode : null, // 信用代码
        keyPersonnel: this.firmInfo.keyPersonnel ? this.firmInfo.keyPersonnel : null, // 主要人员

        product: this.form.product ? this.form.product : '', // 产品服务
        teamIntroduce: this.form.teamIntroduce ? this.form.teamIntroduce : '', // 团队介绍
        gloryDetail: this.form.honorSketch ? this.form.honorSketch : null, // 荣誉描述
        gloryPicture: this.gloryImgList ? this.gloryImgList : null, // 荣誉资质
        developProcedure: this.form.developProcedure !== null ? this.form.developProcedure : '', // 发展历程
        partner: this.form.partner ? this.form.partner : '' // 合作伙伴
      })
      const { code, msg } = res.data
      if (code === 200) {
        const obj = {
          appraiseTime: this.tagIsShow,
          companyName: this.form.firmName ? this.form.firmName : null, // 企业名称
          name: this.form.firmName ? this.form.firmName : null, // 企业名称
          district: this.firmArea, // 所属地区
          registryAddress: this.firmInfo.registryAddress ? this.firmInfo.registryAddress : null, // 注册地址
          phone: this.firmInfo.phone ? this.firmInfo.phone : null, // 联系电话
          website: this.firmInfo.website ? this.firmInfo.website : null, // 网址

          // isPublished: this.firmArea ? this.status : null, // 是否发布
          // publishTime: null, // 最近发布时间
          logo: this.firmLogo ? this.firmLogo.join(',') : null, // 企业logo
          companyPicture: this.firmImgList ? this.firmImgList : null, // 企业图片
          detail: this.form.introductory ? this.form.introductory : null, // 企业简介
          income: this.form.lastIncome ? this.form.lastIncome : null, // 去年营收
          financialTurn: this.form.financingTurn ? this.form.financingTurn : null, // 融资轮次
          financialNums: this.form.financingMoney ? this.form.financingMoney : null, // 融资金额

          industry: this.firmInfo.industry ? this.firmInfo.industry : null, // 行业分类
          bussinessState: this.firmInfo.bussinessState ? this.firmInfo.bussinessState : null, // 经营状态
          scale: this.firmInfo.scale ? this.firmInfo.scale : null, // 人员规模
          legalRepresentative: this.firmInfo.legalRepresentative ? this.firmInfo.legalRepresentative : null, // 法人
          isHightech: this.firmInfo.isHightech ? this.firmInfo.isHightech : null, // 高新
          foundationDate: this.firmInfo.foundationDate ? this.firmInfo.foundationDate : null, // 成立日期
          isPublic: this.firmInfo.isPublic ? this.firmInfo.isPublic : null, // 上市
          registryCapital: this.firmInfo.registryCapital ? this.firmInfo.registryCapital : null, // 注册资本
          patentNumber: this.patentNumber ? this.patentNumber : null, // 知识产权
          type: this.firmInfo.type ? this.firmInfo.type : null, // 公司类型
          creditCode: this.firmInfo.creditCode ? this.firmInfo.creditCode : null, // 信用代码
          keyPersonnel: this.firmInfo.keyPersonnel ? this.firmInfo.keyPersonnel : null, // 主要人员

          product: this.form.product ? this.form.product : null, // 产品服务
          teamIntroduce: this.form.teamIntroduce ? this.form.teamIntroduce : null, // 团队介绍
          gloryDetail: this.form.honorSketch ? this.form.honorSketch : null, // 荣誉描述
          gloryPicture: this.gloryImgList ? this.gloryImgList : null, // 荣誉资质
          developProcedure: this.form.developProcedure !== null ? this.form.developProcedure : null, // 发展历程
          partner: this.form.partner ? this.form.partner : null // 合作伙伴

        }

        this.firmInfoCheck = obj

        sessionStorage.setItem('firmInfoCheck', JSON.stringify(this.firmInfoCheck))
        console.log(this.firmInfoCheck)

        this.$message.success('修改成功！')
        // this.$router.push('/compantInfo')
      } else {
        this.$message.error(msg)
      }
    },

    // 保存
    pageSave () {
      if (this.form.firmName === null) { return this.$message.error('企业名称不能为空！') }
      // this.firmId === null ? this.firmDataUpload() : this.firmDataChange()
      if (this.firmId === null) {
        this.Published = '0'
        this.firmDataUpload()
      } else {
        if (this.$route.query.Published === 'true') {
          this.Published = '1'
        } else {
          this.Published = '0'
        }
        this.firmDataChange()
      }
    },

    // 发布
    pageRelease () {
      const data = new Date()
      const M = (data.getMonth() + 1) >= 10 ? data.getMonth() + 1 : '0' + (data.getMonth() + 1)
      const d = data.getDate() >= 10 ? data.getDate() : '0' + data.getDate()
      const t = data.toLocaleTimeString().split('午').slice(-1).join()
      const nowDate = (data.getUTCFullYear()) + '-' + M + '-' + d + ' ' + t // 当前日期
      console.log(nowDate)

      this.Published = '1'
      this.publishTime = nowDate

      if (this.firmId === null) {
        this.firmDataUpload()
        this.$message.success('发布成功！')
      } else {
        this.firmDataChange()
        this.$message.success('发布成功！')
      }
    },

    scrollLoad () {
      const nowScotop = $('.el-autocomplete-suggestion__wrap').height() // 可视区高度
      // const lastEle = b[this.falls.length - 1].getBoundingClientRect().bottom // 最后一个元素的底边距离
      // const footerHeight = this.$refs.footer.offsetHeight // 底部的高度
      console.log(nowScotop)
      // console.log(this.restaurants[(this.restaurants.length - 1)])

      // console.log($('div').attr('class'))
      // if (this.onFetching) {
      //   // do nothing
      // } else {
      //   if (nowScotop >= lastEle + footerHeight - 5) {
      //     this.onFetching = true
      //     setTimeout(() => {
      //       this.page += 1
      //       this.getData()
      //       this.arr.length < this.page * 7 ? this.flag = 1 : this.flag = 0
      //       this.onFetching = false
      //     }, 500)
      //   }
      // }
    },

    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped lang="less">
.firmSituation {
  width: 100%;
  height: 100%;
  // background-color: lavenderblush;
}
.acitiveNav {
  font-size: 18px;
}
.btn-style {
  margin: 0 20px;
}
.input-box {
  width: 720px;
}
.input-boxs {
  width: 420px;
}
.firm-moreInfo {
  font-size: 20px;
  font-weight: 600;
  padding-left: 10px;
  border-left: 4px solid rgb(38, 24, 236);
  margin: 20px 0;
}
.firm-baseInfo {
  position: relative;
  width: 1200px;
  min-height: 350px;
  background-color: #ececec;
  .base-info-fline,
  .base-info-sline {
    font-size: 14px;
    line-height: 40px;
    color: #999;
    .dinfo {
      display: block;
    }
  }
  .base-info-fline {
    position: absolute;
    top: 0;
    left: 50px;
  }
  .base-info-sline {
    position: absolute;
    top: 0;
    right: 200px;
  }
}
/deep/.el-tabs__item {
  font-size: 18px;
}
/deep/.el-scrollbar__thumb {
  height: 20px !important;
}
</style>
